export const mediaMaxWidth = (screenWidth: string) =>
    `@media (max-width: ${screenWidth})`

export const mediaMinWidth = (screenWidth: string) =>
    `@media (min-width: ${screenWidth})`
